import { t } from './dict'
import { formats } from './locale'

/**
 * Display formatting, in the locale cTrader launched us with.
 *
 * One direction only: these format for display and nothing parses their output back. A number
 * that has been through `Intl` carries grouping separators and is no longer a number — which is
 * exactly how an integer volume would stop being an integer. Reading what a human typed is
 * `decimal()` in `i18n/locale.ts`, and it is a different function on purpose.
 *
 * None of these reads a clock. Every instant here arrives from the server as ISO text.
 */

export const money = (n: number): string => formats().money.format(n)

/**
 * Percentages arrive as percentage numbers — `0.5` means 0.5 %, not 50 %. `Intl`'s
 * `style: 'percent'` would need a `/100` at every one of the dozen call sites, which is a
 * silent factor-of-100 waiting to happen, so the unit stays a string. German writes it with a
 * non-breaking space.
 */
export const pct = (n: number): string => `${formats().upTo2.format(n)}${t('unit.percent')}`

export const when = (iso: string | null): string =>
  iso ? formats().dateTime.format(new Date(iso)) : t('unit.none')

export function duration(minutes: number | null): string {
  if (minutes === null) return t('unit.none')
  if (minutes < 60) return `${formats().integer.format(minutes)} ${t('unit.minutes')}`
  if (minutes < 60 * 24) return `${formats().upTo1.format(minutes / 60)} ${t('unit.hours')}`
  return `${formats().upTo1.format(minutes / 60 / 24)} ${t('unit.days')}`
}

/** Days until an ISO instant, negative when past. */
export function daysUntil(iso: string, nowMs: number): number {
  return (Date.parse(iso) - nowMs) / 86_400_000
}
